@if (services.length) {
    <div class="ng-container" [class.showHotelInfo]="isDesktop">
        <div class="ng-beach">
            @for (option of services; track $index) {
                <div class="ng-beach__item">
                    <span class="icon {{ option.icon }}"></span>
                    <span class="name">{{ option.name }}</span>
                </div>
            }
        </div>
    </div>
}
